export class Series {
  public name: string = "";
  public visible: boolean = true;
  public data: any; // Array<any> = new Array<any>();
  public yAxis = 0;
  public tooltip: any;
  public color: string;
  public type: string;
  public showInLegend: boolean;
  public enableMouseTracking: boolean;

  constructor(name: string, data: any) {
    this.name = name;
    this.data = data;
  }
}
